import * as commonStyles from '../common/common.css';
import { sprinkles } from './sprinkles.css';
export const atoms = (c, component) => component ? [commonStyles.resetElement[component], sprinkles(c)] : sprinkles(c);
export const resetByComponent = component => {
  return commonStyles.resetElement[component];
};
//# sourceMappingURL=atoms.js.map